{
  "projectedIncome": "Revenu projeté",
  "totalProjectedIncome": "Revenu total projeté",
  "monthlyAverageIncome": "Revenu mensuel moyen",
  "noData": "Il n'y a aucun revenu projeté disponible"
}
